(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["austpek-request-a-quote"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-apq-app]');

    roots.forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const section = root.closest('.apq');
      const form = root.closest('form');
      const sectionId = section.dataset.sectionId;
      const storageKey = `austpek-rfq-${sectionId}`;
      const routesRoot = window.Shopify?.routes?.root || '/';
      const currency = section.dataset.currency || 'AUD';
      const state = {
        route: '',
        panel: '',
        cart: null,
        includedKeys: new Set(),
        reviewedSignature: '',
        searchTimer: null,
        searchController: null,
        hasInclusionSelection: false,
        isSubmitting: false
      };

      const query = (selector, scope = root) => scope.querySelector(selector);
      const queryAll = (selector, scope = root) => Array.from(scope.querySelectorAll(selector));
      const startScreen = query('[data-screen="start"]');
      const flowScreen = query('[data-screen="flow"]');
      const successScreen = query('[data-screen="success"]');
      const notice = query('[data-notice]');
      const summaryCount = query('[data-summary-count]');
      const summaryContent = query('[data-summary-content]');
      const summaryEditWrap = query('[data-summary-edit-wrap]');
      const quoteBodyField = query('[data-quote-body]');
      const routeField = query('[data-route-field]');
      const productCountField = query('[data-product-count-field]');
      const referenceField = query('[data-quote-reference]');
      const contactNameField = query('[data-contact-name]');

      const createElement = (tag, className, text) => {
        const element = document.createElement(tag);
        if (className) element.className = className;
        if (text !== undefined) element.textContent = text;
        return element;
      };

      const isPresent = (value) => value !== null && value !== undefined && String(value).trim() !== '';

      const money = (cents) => {
        const amount = Number(cents || 0) / 100;
        try {
          return new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency,
            maximumFractionDigits: 0
          }).format(amount);
        } catch (error) {
          return `$${amount.toFixed(0)}`;
        }
      };

      const formatBudget = (value) => {
        if (!isPresent(value)) return '';
        const number = Number(value);
        if (!Number.isFinite(number)) return String(value);
        return new Intl.NumberFormat('en-AU', {
          style: 'currency',
          currency: 'AUD',
          maximumFractionDigits: 0
        }).format(number);
      };

      const publicProperties = (item) => Object.entries(item.properties || {}).filter(([key, value]) => {
        return isPresent(value) && !String(key).startsWith('_');
      });

      const allProperties = (item) => Object.entries(item.properties || {}).filter(([, value]) => isPresent(value));

      const includedItems = () => {
        if (!state.cart?.items) return [];
        return state.cart.items.filter((item) => state.includedKeys.has(item.key));
      };

      const cartSignature = () => {
        if (!state.cart?.items) return '';
        return JSON.stringify(state.cart.items.map((item) => ({
          key: item.key,
          quantity: item.quantity,
          final_line_price: item.final_line_price,
          properties: item.properties || {}
        })));
      };

      const showNotice = (message) => {
        notice.textContent = message;
        notice.hidden = !message;
        if (message) notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };

      const hideNotice = () => showNotice('');

      const getFormSnapshot = () => {
        const fields = queryAll('input[name], textarea[name], select[name]', form);
        const values = {};
        fields.forEach((field) => {
          if (field.type === 'hidden' || field.name === 'contact[body]') return;
          if (field.type === 'checkbox') {
            if (!values[field.name]) values[field.name] = [];
            if (field.checked) values[field.name].push(field.value);
            return;
          }
          if (field.type === 'radio') {
            if (field.checked) values[field.name] = field.value;
            return;
          }
          values[field.name] = field.value;
        });
        return values;
      };

      const saveDraft = () => {
        try {
          sessionStorage.setItem(storageKey, JSON.stringify({
            route: state.route,
            panel: state.panel,
            includedKeys: Array.from(state.includedKeys),
            reviewedSignature: state.reviewedSignature,
            values: getFormSnapshot()
          }));
        } catch (error) {
          return;
        }
      };

      const readDraft = () => {
        try {
          return JSON.parse(sessionStorage.getItem(storageKey) || 'null');
        } catch (error) {
          return null;
        }
      };

      const restoreValues = (values = {}) => {
        Object.entries(values).forEach(([name, value]) => {
          const fields = queryAll(`[name="${CSS.escape(name)}"]`, form);
          fields.forEach((field) => {
            if (field.type === 'checkbox') {
              field.checked = Array.isArray(value) && value.includes(field.value);
            } else if (field.type === 'radio') {
              field.checked = field.value === value;
            } else {
              field.value = value || '';
            }
          });
        });
      };

      const setStep = (step) => {
        queryAll('[data-step-indicator]').forEach((indicator) => {
          const number = Number(indicator.dataset.stepIndicator);
          indicator.classList.toggle('is-active', number === step);
          indicator.classList.toggle('is-complete', number < step);
        });
      };

      const panelStep = (panel) => {
        if (panel === 'project') return 2;
        if (panel === 'contact') return 3;
        return 1;
      };

      const showPanel = (panel, options = {}) => {
        state.panel = panel;
        startScreen.hidden = true;
        successScreen.hidden = true;
        flowScreen.hidden = false;
        queryAll('[data-panel]').forEach((element) => {
          element.hidden = element.dataset.panel !== panel;
        });
        setStep(panelStep(panel));
        summaryEditWrap.hidden = panel !== 'contact';
        updateSummary();
        hideNotice();
        saveDraft();
        if (!options.noScroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      const showStart = () => {
        state.route = '';
        state.panel = '';
        flowScreen.hidden = true;
        successScreen.hidden = true;
        startScreen.hidden = false;
        hideNotice();
        saveDraft();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      const updateStepOneLabel = () => {
        const label = query('[data-step-one-label]');
        label.textContent = state.route === 'build' ? 'Brief' : 'Products';
      };

      const syncRouteControls = () => {
        queryAll('[data-panel="build"] input[name], [data-panel="build"] textarea[name], [data-panel="build"] select[name]')
          .forEach((field) => { field.disabled = state.route !== 'build'; });
      };

      const startRoute = async (route, options = {}) => {
        state.route = route;
        updateStepOneLabel();
        routeField.value = route === 'cart' ? 'Use my cart' : route === 'add' ? 'Add products' : 'Build my package';
        syncRouteControls();
        let cartLoaded = true;
        if (route === 'cart' || route === 'add') {
          cartLoaded = await refreshCart({ preserveSelection: true, silent: true });
        }
        if (state.route !== route) return;
        showPanel(route, options);
        if (!cartLoaded) showNotice('We could not load your cart. Please refresh and try again.');
      };

      const appendImage = (container, source, alt, className) => {
        if (source) {
          const image = document.createElement('img');
          image.className = className;
          image.src = source;
          image.alt = alt || '';
          image.loading = 'lazy';
          container.appendChild(image);
        } else {
          const placeholder = createElement('span', `${className} ${className}-placeholder`, '—');
          placeholder.setAttribute('aria-hidden', 'true');
          container.appendChild(placeholder);
        }
      };

      const appendPropertyList = (container, item) => {
        const properties = publicProperties(item);
        if (!properties.length) return;
        const heading = createElement('span', 'apq__item-meta', 'Selected options');
        container.appendChild(heading);
        const list = createElement('dl', 'apq__property-list');
        properties.forEach(([key, value]) => {
          const term = createElement('dt', '', key);
          const detail = createElement('dd');
          const stringValue = String(value);
          if (/^https?:\/\//i.test(stringValue)) {
            const link = createElement('a', '', 'View uploaded option');
            link.href = stringValue;
            link.target = '_blank';
            link.rel = 'noopener';
            detail.appendChild(link);
          } else {
            detail.textContent = stringValue;
          }
          list.append(term, detail);
        });
        container.appendChild(list);
      };

      const createItemCard = (item) => {
        const article = createElement('article', 'apq__item');
        article.dataset.lineKey = item.key;
        appendImage(article, item.image, item.product_title || item.title, 'apq__item-image');

        const copy = createElement('div', 'apq__item-copy');
        const title = createElement('div', 'apq__item-title');
        const link = createElement('a', '', item.product_title || item.title || 'Product');
        link.href = item.url || '#';
        link.target = '_blank';
        link.rel = 'noopener';
        title.appendChild(link);
        copy.appendChild(title);

        const metaParts = [];
        if (item.variant_title && item.variant_title !== 'Default Title') metaParts.push(item.variant_title);
        if (item.sku) metaParts.push(`SKU ${item.sku}`);
        metaParts.push(`Qty ${item.quantity}`);
        copy.appendChild(createElement('div', 'apq__item-meta', metaParts.join(' · ')));
        appendPropertyList(copy, item);
        article.appendChild(copy);

        const side = createElement('div', 'apq__item-side');
        side.appendChild(createElement('strong', '', money(item.final_line_price)));
        const include = createElement('label', 'apq__include');
        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.checked = state.includedKeys.has(item.key);
        checkbox.dataset.includeLine = item.key;
        checkbox.setAttribute('aria-label', `Include ${item.product_title || item.title || 'product'} in quote`);
        include.append(checkbox, createElement('span', '', 'Included'));
        side.appendChild(include);
        article.appendChild(side);
        return article;
      };

      const renderCart = () => {
        const cartItems = query('[data-cart-items]');
        const addItems = query('[data-add-items]');
        const cartEmpty = query('[data-cart-empty]');
        const addEmpty = query('[data-add-empty]');
        cartItems.replaceChildren();
        addItems.replaceChildren();

        const items = state.cart?.items || [];
        items.forEach((item) => {
          cartItems.appendChild(createItemCard(item));
          addItems.appendChild(createItemCard(item));
        });

        cartEmpty.hidden = items.length > 0;
        addEmpty.hidden = items.length > 0;
        queryAll('[data-panel="cart"] [data-next="project"], [data-panel="add"] [data-next="project"]')
          .forEach((button) => { button.disabled = includedItems().length === 0; });
        query('[data-panel="build"] [data-next="project"]').disabled = false;
        updateSummary();
      };

      const refreshCart = async (options = {}) => {
        const previousIncluded = new Set(state.includedKeys);
        const previousCartKeys = new Set((state.cart?.items || []).map((item) => item.key));
        try {
          const response = await fetch(`${routesRoot}cart.js`, {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
          });
          if (!response.ok) throw new Error('Cart request failed');
          state.cart = await response.json();
          state.includedKeys = new Set();
          state.cart.items.forEach((item) => {
            const isNewLine = !previousCartKeys.has(item.key);
            if (!options.preserveSelection || !state.hasInclusionSelection || previousIncluded.has(item.key) || isNewLine) {
              state.includedKeys.add(item.key);
            }
          });
          state.hasInclusionSelection = true;
          renderCart();
          saveDraft();
          if (!options.silent) showNotice('Products refreshed from your cart.');
          return true;
        } catch (error) {
          if (!options.silent) showNotice('We could not refresh your cart. Please try again.');
          return false;
        }
      };

      const selectedValue = (name) => query(`[name="${CSS.escape(name)}"]:checked`, form)?.value || '';

      const selectedValues = (selector) => queryAll(`${selector}:checked`, form).map((field) => field.value);

      const updateSummary = () => {
        summaryContent.replaceChildren();
        const items = includedItems();
        const count = state.route === 'build' ? selectedValues('[data-package-product]').length : items.length;
        summaryCount.textContent = state.route === 'build'
          ? `${count} ${count === 1 ? 'product group' : 'product groups'}`
          : `${count} ${count === 1 ? 'item' : 'items'}`;

        if (!state.route) {
          summaryContent.appendChild(createElement('p', 'apq__summary-meta', 'Choose how you would like to start.'));
          return;
        }

        if (state.route === 'build') {
          const list = createElement('ul', 'apq__summary-list');
          const space = selectedValue('contact[Space]') || 'Not selected';
          const products = selectedValues('[data-package-product]');
          const budget = query('[data-budget-input]')?.value || '';
          [
            ['Space', space],
            ['Product groups', products.length ? String(products.length) : 'Not selected'],
            ['Budget', budget ? formatBudget(budget) : 'Not supplied']
          ].forEach(([label, value]) => {
            const item = createElement('li');
            item.append(createElement('span', '', label), createElement('span', '', value));
            list.appendChild(item);
          });
          summaryContent.appendChild(list);
          return;
        }

        if (!items.length) {
          summaryContent.appendChild(createElement('p', 'apq__summary-meta', 'No products selected yet.'));
          return;
        }

        const total = items.reduce((sum, item) => sum + Number(item.final_line_price || 0), 0);
        const totalRow = createElement('div', 'apq__summary-total');
        totalRow.append(createElement('span', '', 'Selected products subtotal'), createElement('span', '', money(total)));
        summaryContent.appendChild(totalRow);

        const list = createElement('ul', 'apq__summary-list');
        items.slice(0, 5).forEach((item) => {
          const row = createElement('li');
          row.append(
            createElement('span', '', item.product_title || item.title || 'Product'),
            createElement('span', '', publicProperties(item).length ? 'Configured' : `Qty ${item.quantity}`)
          );
          list.appendChild(row);
        });
        if (items.length > 5) list.appendChild(createElement('li', 'apq__summary-meta', `+ ${items.length - 5} more`));
        summaryContent.appendChild(list);
        summaryContent.appendChild(createElement('p', 'apq__summary-meta', 'Guide only. Final pricing is confirmed in your tailored quote.'));
      };

      const clearErrors = (scope) => {
        queryAll('[aria-invalid="true"]', scope).forEach((field) => field.removeAttribute('aria-invalid'));
        queryAll('.apq__field-error', scope).forEach((error) => { error.hidden = true; });
      };

      const validateRequiredFields = (panel) => {
        clearErrors(panel);
        let valid = true;
        let firstNativeInvalid = null;
        queryAll('input, textarea, select', panel).forEach((field) => {
          if (!field.willValidate || field.checkValidity()) return;
          valid = false;
          firstNativeInvalid ||= field;
          field.setAttribute('aria-invalid', 'true');
          const error = field.closest('.apq__field')?.querySelector('.apq__field-error');
          if (error) error.hidden = false;
        });
        queryAll('[data-required-field]', panel).forEach((field) => {
          const value = field.value.trim();
          const isEmail = field.type === 'email';
          const fieldValid = value && field.checkValidity() && (!isEmail || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value));
          if (!fieldValid) {
            valid = false;
            field.setAttribute('aria-invalid', 'true');
            const error = field.closest('.apq__field')?.querySelector('.apq__field-error');
            if (error) error.hidden = false;
          }
        });
        queryAll('[data-required-group]', panel).forEach((group) => {
          const checked = query('input:checked', group);
          if (!checked) {
            valid = false;
            const error = query(`[data-group-error="${group.dataset.requiredGroup}"]`, group);
            if (error) error.hidden = false;
          }
        });
        if (firstNativeInvalid) firstNativeInvalid.reportValidity();
        return valid;
      };

      const validateStepOne = () => {
        const panel = query(`[data-panel="${state.route}"]`);
        if (state.route === 'build') return validateRequiredFields(panel);
        const valid = includedItems().length > 0;
        const error = query(state.route === 'cart' ? '[data-cart-error]' : '[data-add-error]');
        error.hidden = valid;
        return valid;
      };

      const validateContact = () => {
        const panel = query('[data-panel="contact"]');
        let valid = validateRequiredFields(panel);
        const consent = query('[data-consent]');
        const consentError = query('[data-consent-error]');
        if (!consent.checked) {
          valid = false;
          consentError.hidden = false;
        } else {
          consentError.hidden = true;
        }
        return valid;
      };

      const createReference = () => {
        try {
          const saved = sessionStorage.getItem(`${storageKey}-reference`);
          if (saved) return saved;
        } catch (error) {
          // Continue with an in-memory reference when storage is unavailable.
        }
        const date = new Date();
        const stamp = [
          String(date.getFullYear()).slice(-2),
          String(date.getMonth() + 1).padStart(2, '0'),
          String(date.getDate()).padStart(2, '0')
        ].join('');
        const reference = `AQ-${stamp}-${Math.random().toString(36).slice(2, 7).toUpperCase()}`;
        try {
          sessionStorage.setItem(`${storageKey}-reference`, reference);
        } catch (error) {
          // The hidden contact field still carries this reference to Shopify.
        }
        return reference;
      };

      const buildQuoteBody = () => {
        const lines = [];
        lines.push(`AUSTPEK QUOTE REQUEST`);
        lines.push(`Reference: ${referenceField.value}`);
        lines.push(`Route: ${routeField.value}`);
        lines.push('');

        if (state.route === 'build') {
          lines.push('PACKAGE BRIEF');
          lines.push(`Space: ${selectedValue('contact[Space]')}`);
          lines.push(`Products needed: ${selectedValues('[data-package-product]').join(', ')}`);
          const budget = query('[data-budget-input]')?.value || '';
          lines.push(`Approximate product budget: ${budget ? formatBudget(budget) : 'Not supplied'}`);
        } else {
          lines.push('CONFIGURED PRODUCTS');
          includedItems().forEach((item, index) => {
            lines.push(`${index + 1}. ${item.product_title || item.title || 'Product'}`);
            lines.push(`Line key: ${item.key}`);
            lines.push(`Variant: ${item.variant_title || 'Default'}`);
            lines.push(`Variant ID: ${item.variant_id || item.id || ''}`);
            lines.push(`SKU: ${item.sku || 'Not supplied'}`);
            lines.push(`Quantity: ${item.quantity}`);
            lines.push(`Line price: ${money(item.final_line_price)}`);
            const productUrl = item.url ? new URL(item.url, window.location.origin).href : '';
            lines.push(`Product URL: ${productUrl}`);
            const properties = allProperties(item);
            if (properties.length) {
              lines.push('Line item properties:');
              properties.forEach(([key, value]) => lines.push(`- ${key}: ${String(value)}`));
            } else {
              lines.push('Line item properties: None');
            }
            if (item.selling_plan_allocation?.selling_plan?.name) {
              lines.push(`Selling plan: ${item.selling_plan_allocation.selling_plan.name}`);
            }
            lines.push('');
          });
          lines.push(`Selected products subtotal: ${money(includedItems().reduce((sum, item) => sum + Number(item.final_line_price || 0), 0))}`);
        }

        lines.push('');
        lines.push('PROJECT');
        lines.push(`Postcode: ${query('[name="contact[Project postcode]"]')?.value || ''}`);
        lines.push(`Project type: ${selectedValue('contact[Project type]')}`);
        lines.push(`Timing: ${selectedValue('contact[Timing]')}`);
        lines.push(`Plans or schedule: ${query('[name="contact[Plans or schedule link]"]')?.value || 'Not supplied'}`);
        lines.push(`Notes: ${query('[name="contact[Project notes]"]')?.value || 'Not supplied'}`);
        lines.push('');
        lines.push('This quote request does not place an order, reserve stock or change the customer cart.');
        return lines.join('\n');
      };

      const renderSearchResults = (products) => {
        const container = query('[data-search-results]');
        const status = query('[data-search-status]');
        container.replaceChildren();
        if (!products.length) {
          status.textContent = 'No matching products found.';
          return;
        }
        status.textContent = `${products.length} ${products.length === 1 ? 'product' : 'products'} found.`;
        products.forEach((product) => {
          const article = createElement('article', 'apq__result');
          const imageUrl = product.featured_image?.url || product.image || '';
          appendImage(article, imageUrl, product.featured_image?.alt || product.title, 'apq__result-image');
          const copy = createElement('div', 'apq__result-copy');
          const title = createElement('div', 'apq__result-title');
          const titleLink = createElement('a', '', product.title);
          titleLink.href = product.url;
          titleLink.target = '_blank';
          titleLink.rel = 'noopener';
          title.appendChild(titleLink);
          copy.appendChild(title);
          if (isPresent(product.price)) {
            copy.appendChild(createElement('span', 'apq__result-price', `From ${money(Number(product.price) * 100)}`));
          }
          article.appendChild(copy);
          const action = createElement('a', 'apq__result-action', 'Configure options');
          action.href = product.url;
          action.target = '_blank';
          action.rel = 'noopener';
          action.setAttribute('aria-label', `Configure ${product.title} options (opens in a new tab)`);
          action.dataset.configureProduct = 'true';
          article.appendChild(action);
          container.appendChild(article);
        });
      };

      const searchProducts = async (term) => {
        const status = query('[data-search-status]');
        const results = query('[data-search-results]');
        if (state.searchController) state.searchController.abort();
        if (term.trim().length < 2) {
          status.textContent = '';
          results.replaceChildren();
          return;
        }
        state.searchController = new AbortController();
        const requestedTerm = term.trim();
        status.textContent = 'Searching…';
        try {
          const params = new URLSearchParams({
            q: requestedTerm,
            'resources[type]': 'product',
            'resources[limit]': '6',
            'resources[options][unavailable_products]': 'last',
            'resources[options][fields]': 'title,product_type,variants.title,vendor,variants.sku'
          });
          const response = await fetch(`${routesRoot}search/suggest.json?${params.toString()}`, {
            headers: { Accept: 'application/json' },
            signal: state.searchController.signal,
            credentials: 'same-origin'
          });
          if (!response.ok) throw new Error('Search failed');
          const data = await response.json();
          if (query('[data-product-search]').value.trim() !== requestedTerm) return;
          const products = data.resources?.results?.products || [];
          renderSearchResults(products);
        } catch (error) {
          if (error.name === 'AbortError') return;
          results.replaceChildren();
          status.textContent = 'Search is unavailable right now. Browse the catalogue and return here after adding products.';
        }
      };

      queryAll('[data-route]').forEach((button) => {
        button.addEventListener('click', () => startRoute(button.dataset.route));
      });

      queryAll('[data-switch-route]').forEach((button) => {
        button.addEventListener('click', () => startRoute(button.dataset.switchRoute));
      });

      queryAll('[data-back-start]').forEach((button) => button.addEventListener('click', showStart));

      queryAll('[data-refresh-cart]').forEach((button) => {
        button.addEventListener('click', () => refreshCart({ preserveSelection: true }));
      });

      queryAll('[data-next="project"]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!validateStepOne()) return;
          state.reviewedSignature = state.route === 'build' ? '' : cartSignature();
          showPanel('project');
        });
      });

      query('[data-next="contact"]').addEventListener('click', () => {
        const projectPanel = query('[data-panel="project"]');
        if (!validateRequiredFields(projectPanel)) return;
        showPanel('contact');
      });

      queryAll('[data-back]').forEach((button) => {
        button.addEventListener('click', () => {
          const target = button.dataset.back === 'step-one' ? state.route : button.dataset.back;
          showPanel(target);
        });
      });

      queryAll('[data-summary-edit]').forEach((button) => {
        button.addEventListener('click', () => {
          showPanel(button.dataset.summaryEdit === 'products' ? state.route : 'project');
        });
      });

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-include-line]')) {
          if (event.target.checked) state.includedKeys.add(event.target.dataset.includeLine);
          else state.includedKeys.delete(event.target.dataset.includeLine);
          state.hasInclusionSelection = true;
          renderCart();
        }
        updateSummary();
        saveDraft();
      });

      root.addEventListener('input', () => {
        updateSummary();
        saveDraft();
      });

      const searchInput = query('[data-product-search]');
      searchInput.addEventListener('input', () => {
        window.clearTimeout(state.searchTimer);
        state.searchTimer = window.setTimeout(() => searchProducts(searchInput.value), 280);
      });

      root.addEventListener('click', (event) => {
        const configureLink = event.target.closest('[data-configure-product]');
        if (configureLink) {
          saveDraft();
          showNotice('Product page opened. Configure it with VO Product Options, add it to your cart, then return here.');
        }
      });

      form.addEventListener('submit', async (event) => {
        if (state.isSubmitting) return;
        event.preventDefault();
        if (!validateContact()) return;
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        const submittedRoute = state.route;
        state.isSubmitting = true;
        query('[data-submit-quote]').disabled = true;
        const resetSubmitting = () => {
          state.isSubmitting = false;
          query('[data-submit-quote]').disabled = false;
        };

        if (state.route !== 'build') {
          const previousSignature = state.reviewedSignature;
          const refreshed = await refreshCart({ preserveSelection: true, silent: true });
          if (!refreshed) {
            resetSubmitting();
            showNotice('We could not verify the current cart. Please refresh and try again.');
            return;
          }
          if (state.route !== submittedRoute || state.panel !== 'contact') {
            resetSubmitting();
            return;
          }
          if (previousSignature && previousSignature !== cartSignature()) {
            resetSubmitting();
            showPanel(state.route, { noScroll: true });
            showNotice('Your cart changed since you reviewed it. Check the products and selected options before continuing.');
            return;
          }
          if (!includedItems().length) {
            resetSubmitting();
            showPanel(state.route, { noScroll: true });
            showNotice('Select at least one product for the quote.');
            return;
          }
        }

        if (!validateContact() || !form.checkValidity()) {
          resetSubmitting();
          form.reportValidity();
          return;
        }

        const reference = createReference();
        referenceField.value = reference;
        contactNameField.value = [
          query('[name="contact[First name]"]')?.value,
          query('[name="contact[Last name]"]')?.value
        ].filter(Boolean).join(' ');
        productCountField.value = state.route === 'build'
          ? selectedValues('[data-package-product]').length
          : includedItems().length;
        quoteBodyField.value = buildQuoteBody();
        saveDraft();
        form.requestSubmit();
      });

      const refreshOnReturn = () => {
        if ((state.route === 'cart' || state.route === 'add') && !document.hidden) {
          refreshCart({ preserveSelection: true, silent: true });
        }
      };
      window.addEventListener('focus', refreshOnReturn);
      window.addEventListener('pageshow', refreshOnReturn);
      document.addEventListener('visibilitychange', refreshOnReturn);

      const postedSuccessfully = root.dataset.postedSuccessfully === 'true';
      if (postedSuccessfully) {
        const draft = readDraft();
        let reference = 'AQ-RECEIVED';
        try {
          reference = sessionStorage.getItem(`${storageKey}-reference`) || reference;
        } catch (error) {
          // Use the fallback reference when storage is unavailable.
        }
        const email = draft?.values?.['contact[email]'] || 'your email';
        startScreen.hidden = true;
        flowScreen.hidden = true;
        successScreen.hidden = false;
        query('[data-success-reference]').textContent = reference;
        query('[data-success-email]').textContent = email;
        try {
          sessionStorage.removeItem(storageKey);
          sessionStorage.removeItem(`${storageKey}-reference`);
        } catch (error) {
          // Nothing else is required after a successful post.
        }
        return;
      }

      const draft = readDraft();
      if (draft?.values) restoreValues(draft.values);
      if (Array.isArray(draft?.includedKeys)) {
        state.includedKeys = new Set(draft.includedKeys);
        state.hasInclusionSelection = true;
      }
      if (draft?.reviewedSignature) state.reviewedSignature = draft.reviewedSignature;
      if (root.dataset.hasErrors === 'true') {
        state.route = draft?.route || 'build';
        updateStepOneLabel();
        routeField.value = state.route === 'cart' ? 'Use my cart' : state.route === 'add' ? 'Add products' : 'Build my package';
        syncRouteControls();
        showPanel('contact', { noScroll: true });
      } else if (draft?.route && draft?.panel) {
        const draftRoute = draft.route;
        startRoute(draftRoute, { noScroll: true }).then(() => {
          if (state.route === draftRoute) showPanel(draft.panel, { noScroll: true });
        });
      } else {
        showStart();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-compare"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.before-after-slider-section .containered');

  containers.forEach((container) => {
    const slider = container.querySelector('.slider');
    slider.addEventListener('input', (e) => {
      container.style.setProperty('--position', `${e.target.value}%`);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
